
const deviceRechargeInfoMoudle={
  namespaced: true,
  state:{
    searchSN:''
  },
  mutations:{

  },
  getters:{

  },
  actions:{

  }
};

export default deviceRechargeInfoMoudle;



// WEBPACK FOOTER //
// ./src/store/moudles/deviceRechargeInfo.js